import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBIntField, DBCheckBox, DBTextArea } from '_components';
import styles from './Common.module.css'

class PatientCareCenterNotePlanBodyDC extends React.Component {
    render() {
        return (
            <div>
                <div className={styles.row}>
                    <span className={this.props.isValidationRequired ? styles.label_req : styles.label_not_req}>Discharge Reason</span>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLWPDCGOALSMET'
                        label='Goals met'
                        className={styles.radio}
                    />
                    {this.props.gpmSelected &&
                        (<><DBIntField
                            noteId={this.props.noteId}
                            entity='PTPLAN'
                            entityKeyColumn='PLNO'
                            entityKeyValue={this.props.plno}
                            field='PLWPDCGOALSMETPERCENT'
                            className={this.props.isPercentageRequired ? styles.percent_input : styles.percent_txt}
                        /> % </>)
                    }
                </div>

                <div className={styles.row}>
                    <span className={styles.label_req} />
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLWPDCINSTRUCTEDHEP'
                        label='Instructed in HEP'
                        className={styles.radio}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.label_req} />
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLWPDCPOORCOMPLIANCE'
                        label='Poor compliance'
                        className={styles.radio}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.label_req} />
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLWPDCMETJOBREQS'
                        label='Met job requirements'
                        className={styles.radio}
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.label_req} />
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLWPDCFCE'
                        label='FCE to determine safe RTW status'
                        className={styles.radio}
                    />
                </div>
                
                <div className={styles.row}>
                <span className={styles.label_req} />
               
                <label className={styles.comment_label}>Comments:</label>
                
                <DBTextArea
                    noteId={this.props.noteId}
                    entity='PTPLAN'
                    entityKeyColumn='PLNO'
                    entityKeyValue={this.props.plno}
                    field='PLCOMMENTS'
                    className={styles.textarea}
                /></div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}


function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let plno = parseInt(Object.keys(state.entities.notes.PTPLAN)
        .find(key => (state.entities.notes.PTPLAN[key].PLEVNO === pk && noteType === 1)
            || (state.entities.notes.PTPLAN[key].PLNTNO === pk && noteType !== 1)));
    let plan = state.entities.notes.PTPLAN[plno];
    let gpmSelected = plan.PLWPDCGOALSMET !== null;
    let isPercentageRequired = false;
    if(gpmSelected){
        isPercentageRequired = plan.PLWPDCGOALSMETPERCENT === null
    }
   
    let isValidationRequired = plan.PLWPDCGOALSMET === null 
    && plan.PLWPDCINSTRUCTEDHEP === null 
    && plan.PLWPDCPOORCOMPLIANCE === null 
    && plan.PLWPDCMETJOBREQS === null 
    && plan.PLWPDCFCE === null;

    return {
        noteId,
        plno,
        plan,
        gpmSelected,
        isValidationRequired,
        isPercentageRequired
    };
}

const connectedPatientCareCenterNotePlanBodyDC = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNotePlanBodyDC);
export { connectedPatientCareCenterNotePlanBodyDC as PatientCareCenterNotePlanBodyDC };

